import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@bibliocommons/base-buttons';
import { ChevronDown, ChevronUp } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './ExpandButton.scss';

const defaultRenderLabel = (isExpanded, textKey) => {
  const labelKey = isExpanded ? 'button_show_less' : 'button_show_more';

  return (
    <>
      <span aria-hidden>
        <FormattedMessage id={labelKey} />
      </span>
      <ScreenReaderMessage>
        <FormattedMessage id={`${labelKey}_${textKey}`} />
      </ScreenReaderMessage>
    </>
  );
};

const ExpandButton = ({ className, handleToggle, hasIcon, isExpanded, renderLabel, textKey }) => {
  return (
    <TextButton
      aria-expanded={isExpanded}
      className={`cp-expand-button ${className}`}
      dataKey="expand-button"
      handleClick={handleToggle}
      inline
      leftAligned
      type="button"
    >
      {renderLabel(isExpanded, textKey)}
      {hasIcon && <>{isExpanded ? <ChevronUp /> : <ChevronDown />}</>}
    </TextButton>
  );
};

ExpandButton.defaultProps = {
  className: '',
  hasIcon: true,
  renderLabel: defaultRenderLabel,
  textKey: ''
};

ExpandButton.propTypes = {
  className: PropTypes.string,
  handleToggle: PropTypes.func.isRequired,
  hasIcon: PropTypes.bool,
  isExpanded: PropTypes.bool.isRequired,
  renderLabel: PropTypes.func,
  textKey: PropTypes.string
};

export default ExpandButton;
